import { Component, OnInit, input } from '@angular/core';

import { SessionService } from "../../services/session.service";

@Component({
    selector: 'reveal-password',
    templateUrl: './reveal-password.component.html',
    standalone: false
})
export class RevealPasswordComponent implements OnInit {
  readonly theInputId = input<string>("");
  // public showPassword: boolean = false;

  constructor(public session: SessionService) {
    session.showPassword = false;
  };

  ngOnInit(): void {
    this.session.showPassword = false;
  }

  showPasswordAsText(id: string) {
      let inputPassword = (<HTMLInputElement>document.getElementById(this.theInputId()));

      if (this.session.showPassword) {
          inputPassword.type = "text";
      } else {
          inputPassword.type = "password";
      }
  }
}
